export default async function ({ store, redirect, app, $session }) {
  if (process.browser) {
    if (!(await $session.isValid())) {
      return redirect('/')
    }

    // carga emisor
    const result = await store.dispatch('facturacion/emisorStore/readByUserId')

    // carga parametros de facturacion
    if (result) {
      console.time('INIT')
      await Promise.all([
        // check user profile
        store.dispatch('admin/userStore/checkProfile'),
        // carga roles
        store.dispatch('admin/roleStore/readAllByEmisor', {
          restart: false,
          limit: 100 // esta version solo carga 100 roles
        }),
        store.dispatch('facturacion/facturaStore/readParams'),
        // tipo cambio
        // TODO: si tiene conta, debe tomar el TC del módulo y no fijo del BCCR.
        store.dispatch('facturacion/facturaStore/readTipoCambioBCCR').catch(() => {})
      ]).then(() => {
        console.log('Emisor Cargado')
      })

      if (result.accountingModule) {
        // promise all para cargar cuentas y tipo de cambio
        await Promise.all([
          store.dispatch('contabilidad/accountStore/readAllByEmisor', { restart: false }).catch(() => {}),
          store.dispatch('contabilidad/exchangeStore/readByEmisor', { restart: false }).catch(() => {})
        ]).then(() => {
          console.log('Cuentas Contables y Tipo de Cambio Cargados')
        })
      }

      console.timeEnd('INIT')
    }
  }
}
